<template>
  <div class>
    <BaseTemp>
      <template v-slot:content>
        <div class="row">
          <h2>Publikationen</h2>
        </div>

        <!-- <b-card
    title="Card Title"
    
    tag="article"
    style="max-width: 20rem;"
    class="mb-2"
  >
    <b-card-text>
      Some quick example text to build on the card title and make up the bulk of the card's content.
    </b-card-text>

    <b-button href="#" variant="primary">Go somewhere</b-button>
  </b-card> -->

        <div style="width: 930px;">
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="row"
              :elevation="hover ? 12 : 2"
            >
              <v-card-title>
                <h4>
                  Die RSA Verschlüsselung 
                </h4>
              </v-card-title>
              <v-card-text>
                <i
                  data-v-fae5bece=""
                  aria-hidden="true"
                  class="fa fa-file-pdf-o"
                />&nbsp;
                <a
                  target="_blank"
                  href="/publications/2014-06-26_PROSEMINAR_RSA_Manns_v4.pdf"
                >RSA Verschlüsselung.pdf</a>
              </v-card-text>
            </v-card>
          </v-hover>
        





          <v-hover v-slot:default="{ hover }">
            <v-card
              class="row"
              :elevation="hover ? 12 : 2"
            >
              <v-card-title>
                <h4>
                  Elliptische Kurven in der Kryptografie 
                </h4>
              </v-card-title>
              <v-card-text>
                <i
                  data-v-fae5bece=""
                  aria-hidden="true"
                  class="fa fa-file-pdf-o"
                />&nbsp;
                <a
                  target="_blank"
                  href="/publications/20171027_BachelorThesis_elliptischeKurvenInDerKryptografie_v3.pdf"
                >Elliptische Kurven.pdf</a>
              </v-card-text>
            </v-card>
          </v-hover>

          <v-hover v-slot:default="{ hover }">
            <v-card
              class="row"
              :elevation="hover ? 12 : 2"
            >
              <v-card-title>
                <h4>
                  Fixed parameter algorithm to find the maximum independent set for k-outerplanar graphs
                </h4>
              </v-card-title>
              <v-card-text>
                <i
                  data-v-fae5bece=""
                  aria-hidden="true"
                  class="fa fa-file-pdf-o"
                />&nbsp;
                <a
                  target="_blank"
                  href="/publications/20191127_FPA_IndependentSet_MasterseminarWS1920_Manns.pdf"
                >FPA Independent Set.pdf</a>
              </v-card-text>
            </v-card>
          </v-hover>
        </div>
      </template>
    </BaseTemp>
  </div>
</template>


<style lang="css">
.elevation-12{
box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12) !important;
}



</style>

<script>
import BaseTemp from "@/components/BaseTemp.vue";

export default {
  name: "PubsComp",
  components: { BaseTemp }
};
</script>